import type { SVGProps } from 'react';

export const SortList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{'sort list'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <rect height="32px" width="32px" x="0" y="0" />
      <g transform="translate(0.000000, 5.000000)">
        <g>
          <polygon points="0 0 32 0 32 22 0 22" />
          <path
            d="M30.3925361,19.6443715 C30.3925361,20.077179 30.0321211,20.429581 29.5887559,20.429581 L2.41134053,20.429581 C1.96797539,20.429581 1.60756036,20.077179 1.60756036,19.6443715 L1.60756036,2.35562852 C1.60756036,1.92250696 1.96797539,1.57041902 2.41134053,1.57041902 L29.5887559,1.57041902 C30.0321211,1.57041902 30.3925361,1.92250696 30.3925361,2.35562852 L30.3925361,19.6443715 Z M29.5887559,0 L2.41134053,0 C1.08156661,0 0,1.05657791 0,2.35562852 L0,19.6443715 C0,20.9434221 1.08156661,22 2.41134053,22 L29.5887559,22 C30.9185298,22 32.0000965,20.9434221 32.0000965,19.6443715 L32.0000965,2.35562852 C32.0000965,1.05657791 30.9185298,0 29.5887559,0 L29.5887559,0 Z"
            fill={props.fill}
          />
        </g>
        <polygon
          fill={props.fill}
          points="4.46464523 8.99925476 5.6011904 10.109541 9.11756792 6.67472054 9.11756792 16.6060504 10.7251283 16.6060504 10.7251283 6.67472054 14.2408628 10.109541 15.3774079 8.99925476 9.9213481 3.66862446"
        />
        <polygon
          fill={props.fill}
          points="22.6699448 14.710272 22.6699448 4.77894211 21.0623844 4.77894211 21.0623844 14.710272 17.5463284 11.2754515 16.4097832 12.3857377 21.8661646 17.716368 27.3228674 12.3857377 26.1863223 11.2754515"
        />
      </g>
    </g>
  </svg>
);
